import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { selectedTemplateBoardSelector } from '../boardTemplatePickerSelectors';

import { isTemplateExampleBoard } from '../../../../common/templates/templateUtil';

import BoardOperationSpinner from '../../../components/loaders/BoardOperationSpinner';
import { boardTemplatePickerContext } from '../context/boardTemplatePickerContext';

const BoardTemplatePickerCopyLoader = () => {
    const { selectedTemplateId, keepTemplateContentChecked } = useContext(boardTemplatePickerContext);

    const selectedTemplateBoard = useSelector((state) => selectedTemplateBoardSelector(state, selectedTemplateId));
    const isClearingTemplateContent = !keepTemplateContentChecked && isTemplateExampleBoard(selectedTemplateBoard);

    return (
        <BoardOperationSpinner className="BoardTemplatePickerCopyLoader">
            {isClearingTemplateContent ? 'Clearing template...' : 'Copying template...'}
        </BoardOperationSpinner>
    );
};

export default BoardTemplatePickerCopyLoader;
